import React from 'react';
import colors from 'Assets/sass/core/vars.scss';
import {useIntl} from "react-intl";

const EventReports = (props) => {
    const event = props.element.event;
    const {messages}  = useIntl();
    const selectEventTypeOptions = [
        {id: "Drive", label: messages['generatedReport_drive']},
        {id: "Ignition Off", label: messages['generatedReport_ignitionOff']},
        {id: "Ignition On", label: messages['generatedReport_ignitionOn']},
        {id: "Travel Start", label: messages['generatedReport_travelStart']},
        {id: "Travel Stop", label: messages['generatedReport_travelStop']},
        {id: "Main Power Off", label: messages['generatedReport_mainPowerOff']},
        {id: "Main Power On", label: messages['generatedReport_mainPowerOn']},
        {id: "Input Off", label: messages['generatedReport_inputOff']},
        {id: "Input On", label: messages['generatedReport_inputOn']},
        {id: "Antenna Disconnect", label: messages['generatedReport_antennaDisconnect']},
        {id: "Antenna Connect", label: messages['generatedReport_antennaConnect']},
        {id: "Internal Battery Disconnect", label: messages['generatedReport_internalBatteryDisconnect']},
        {id: "Internal Battery Connect", label: messages['generatedReport_internalBatteryConnect']},
        {id: "Main Power Connect", label: messages['generatedReport_mainPowerConnect']},
        {id: "Main Power Disconnect", label: messages['generatedReport_mainPowerDisconnect']},
        {id: "Power Down", label: messages['generatedReport_powerDown']},
        {id: "Power Lost", label: messages['generatedReport_powerLost']},
        {id: "Power Off", label: messages['generatedReport_powerOff']},
        {id: "Power On", label: messages['generatedReport_powerOn']},
        {id: "Power Protect", label: messages['generatedReport_powerProtect']},
        {id: "Power Up", label: messages['generatedReport_powerUp']},
        {id: "Vehicle Movement", label: messages['generatedReport_vehicleMovement']},
        {id: "IDLING_END", label: messages['generatedReport_iDLING_END']},
        {id: "Tow", label: messages['generatedReport_tow']},
        {id: "trip_ongoing", label: messages['generatedReport_trip_ongoing']},
        {id: "Update", label: messages['generatedReport_update']},
        {id: "Light Sensor Alarm", label: messages['generatedReport_lightSensorAlarm']},
        {id: "Diagnostic", label: messages['generatedReport_diagnostic']},
        {id: "Sudden Stop", label: messages['generatedReport_suddenStop']},
        {id: "Overfill", label: messages['generatedReport_overfill']},
        {id: "Enter", label: messages['generatedReport_enter']},
        {id: "Exit", label: messages['generatedReport_exit']},
    ]

    const eventsColors = [
        {
            label: 'Ignition On',
            color: '#00AEEF',
            id: 1
        },
        {
            label: 'Ignition Off',
            color: '#ED2020',
            id: 2
        },
        {
            label: 'Travel Stop',
            color: '#ED2020',
            id: 3
        },
        {
            label: 'Travel Start',
            color: '#2AAC30',
            id: 4
        },
        {
            label: 'Ping',
            color: '#2AAC30',
            id: 5
        },
        {
            label: 'Idle',
            color: '#FF7337',
            id: 6
        },
        {
            label: 'Main Power Off',
            color: '#ED2020',
            id: 7
        },
        {
            label: 'Drive',
            color: '#2AAC30',
            id: 8
        },
        {
            label: 'Hard Turn',
            color: '#7B37D2',
            id: 9
        },
        {
            label: 'Hard Brake',
            color: '#7B37D2',
            id: 10
        },
        {
            label: 'Stop',
            color: '#ED2020',
            id: 11
        },
        {
            label: 'Rapid Acceleration',
            color: '#7B37D2',
            id: 12
        },
        {
            label: 'Main Power Disconnect',
            color: '#ED2020',
            id: 13
        },
        {
            label: 'IDLE',
            color: '#FF7337',
            id: 14
        },
        {
            label: 'MOVE',
            color: '#2AAC30',
            id: 15
        },
        {
            label: 'IDLING_END',
            color: '#FF7337',
            id: 16
        },
    ];

    const renderViewEvent = () => {
        const filterEvent = eventsColors.find((ev) => ev.label === event)
        const selectedEvent = selectEventTypeOptions.find(evn => evn.id === event)
        if (filterEvent) {
            return (<strong style={{color: filterEvent ? filterEvent?.color : colors.black}}>{messages['generatedReport_event_' + filterEvent.id]}</strong>)
        } else if (selectedEvent) {
            return (<strong style={{color: filterEvent ? filterEvent?.color : colors.black}}>{messages['generatedReport_' + toCamelCase(selectedEvent.id)]}</strong>)
        } else {
            const eventRefactor = toCamelCase(event);
            return (<strong
                style={{color: filterEvent ? filterEvent?.color : colors.black}}>{messages['videoMainView_' + eventRefactor] ?? (eventRefactor)}</strong>)
        }
    }

    const toCamelCase = (str) => {
        return str
            .toLowerCase()
            .replace(/'|"/g, '')
            .split(' ')
            .map((word, index) => {
                if (index === 0) return word;
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join('');
    }

    return (
        <span>
            {renderViewEvent()}
        </span>
    )
}

export default EventReports;
